export default {
    reprocess_odometer_hours_title: "Reprocess Odometer & Engine Hours",
    reprocess_odometer_hours_account: "Account",
    reprocess_odometer_hours_devices: "Devices",
    reprocess_odometer_hours_input: "IMEI or Serial",
    reprocess_odometer_hours_imei: "IMEI",
    reprocess_odometer_hours_serial: "Serial",
    reprocess_odometer_hours_model: "Model",
    reprocess_odometer_hours_all: "All Devices",
    reprocess_odometer_hours_specific: "Specific Devices",
    reprocess_odometer_hours_start_reprocess: "Start Reprocess",
    reprocess_odometer_hours_reprocess_date: "Reprocess Date",
    reprocess_odometer_hours_devices_to_reprocess: "Devices to Reprocess:",
    reprocess_odometer_hours_selected_date: "Selected Date:",
    reprocess_odometer_hours_message: "The status of the process can be followed in the transactions section.",
    reprocess_odometer_hours_success_message: "the reprocess has been registered, click here to see the status",
    reprocess_odometer_hours_error_message: "Unable to register the reprocess due to an error",
    reprocess_odometer_hours_device_is_already_added: "The device is already added",
    reprocess_odometer_hours_device_has_not_been_found: "The device has not been found",
    reprocess_odometer_hours_high_init_message: "Are you sure that want to sent",
    reprocess_odometer_hours_devices_message: "devices to reprocess? this could cause an extra effort on hour system",
    reprocess_odometer_hours_date_range_message: "months to reprocess? this could cause an extra effort on hour system",
    reprocess_odometer_hours_devices: "devices",
    reprocess_odometer_hours_and: "and",
    reprocess_odometer_hours_months: "months to reprocess? this could cause an extra effort on hour system",
    reprocess_odometer_hours_start_date: "Start Date",
    reprocess_odometer_hours_end_date: "End Date",
    reprocess_odometer_hours_type: "Reprocess Aggregations Type",
    reprocess_odometer_hours_type_update: "Update",
    reprocess_odometer_hours_type_rebuild: "Rebuild",
    reprocess_odometer_hours_devices_mode: "Devices To Reprocess",
    reprocess_odometer_hours_no_units_found: "There are no units available for this account",

}

